import { render } from "./ParameterComponent.vue?vue&type=template&id=2076c921"
import script from "./ParameterComponent.vue?vue&type=script&lang=js"
export * from "./ParameterComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__